import React from 'react';
import Sidebar from './Sidebar';
import GlobalProgressBar from './GlobalProgressBar';
import './layout.css';

const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <GlobalProgressBar />
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;